<template>
  <div>
    <div class="mb-2">
      <label class="form-label">Адрес</label>
      <input v-model="data.address" type="text" class="form-control" placeholder="Введите адрес" />
    </div>

    <div class="mb-2">
      <label class="form-label">Телефон</label>
      <input v-model="data.phone" type="text" class="form-control" placeholder="Введите телефон" />
    </div>

    <div class="mb-2">
      <label class="form-label">Url адрес</label>
      <input v-model="data.url" type="text" class="form-control" placeholder="Введите Url адрес" />
    </div>

    <div class="mb-2">
      <label class="form-label">Общая информация</label>
      <textarea v-model="data.common_info" class="form-control" placeholder="Общая информация" rows="9" />
    </div>
  </div>
</template>

<script setup>
import { reactive, watch, onMounted } from 'vue'
import { debounce } from 'lodash'
//import Helper from "@/services/Helper"

const emit = defineEmits(['onUpdate'])

const props = defineProps({
  payload: {
    type: Object,
    default: () => ({
      val: {
        address: '',
        phone: '',
        url: '',
        common_info: '',
      }
    })
  }
})

// реактивные данные
const data = reactive({
  address: '',
  phone: '',
  url: '',
  common_info: '',
})

// инициализация из payload.val
onMounted(() => {
  if (props.payload?.val) {
    Object.assign(data, props.payload.val)
  }
})

// debounce emit
const emitUpdate = debounce(() => {
  emit('onUpdate', {...data})
}, 300)

// watch всех полей
watch(data, emitUpdate, {deep: true})
</script>
